// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as NextBanner from "../../resources/feedback-indicators/NextBanner.res.js";
import * as SessionTracker from "../../core/SessionTracker.res.js";
import * as InputNumberField from "../../resources/selection-and-input/InputNumberField.res.js";
import * as ToggleButtonGroup from "../../resources/actions/ToggleButtonGroup.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function globalFeeKindToText(kind) {
  if (kind === "FeePerUnit") {
    return I18n.t("Per unit");
  } else {
    return I18n.t("Price prorata");
  }
}

function OrderCartGlobalFeePickerModal(props) {
  let onCommit = props.onCommit;
  let match = React.useState(() => ({
    amount: 0,
    globalFeeKind: "FeePerUnit"
  }));
  let setValue = match[1];
  let value = match[0];
  let captureEvent = SessionTracker.useCaptureEvent();
  let onCommit$1 = React.useCallback(() => {
    onCommit(value);
    captureEvent("cart_global_shipping_costs_click_apply");
  }, [value]);
  return JsxRuntime.jsx(Modal.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsxs(Stack.make, {
        children: [
          JsxRuntime.jsx(InputNumberField.make, {
            value: value.amount,
            minValue: 0,
            precision: 2,
            label: I18n.t("Total amount excl. VAT"),
            appender: {
              TAG: "Currency",
              _0: "EUR"
            },
            required: false,
            onChange: amount => setValue(prev => ({
              amount: amount,
              globalFeeKind: prev.globalFeeKind
            }))
          }),
          JsxRuntime.jsx(ToggleButtonGroup.make, {
            label: I18n.t("Allocation of costs"),
            tooltip: JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(Tooltip.Span.make, {
                  text: I18n.t("order_cart.global_fee_picker_modal.allocation_of_costs.tooltip.label_1"),
                  italic: true,
                  bold: true
                }),
                JsxRuntime.jsx(Tooltip.Gap.make, {}),
                JsxRuntime.jsx(Tooltip.Span.make, {
                  text: I18n.t("order_cart.global_fee_picker_modal.allocation_of_costs.tooltip.content_1")
                }),
                JsxRuntime.jsx(Tooltip.Gap.make, {}),
                JsxRuntime.jsx(Tooltip.Gap.make, {
                  space: "small"
                }),
                JsxRuntime.jsx(Tooltip.Span.make, {
                  text: I18n.t("order_cart.global_fee_picker_modal.allocation_of_costs.tooltip.label_2"),
                  italic: true,
                  bold: true
                }),
                JsxRuntime.jsx(Tooltip.Gap.make, {}),
                JsxRuntime.jsx(Tooltip.Span.make, {
                  text: I18n.t("order_cart.global_fee_picker_modal.allocation_of_costs.tooltip.content_2")
                })
              ]
            }),
            grow: true,
            items: [
              {
                key: "per-unit",
                label: I18n.t("Per unit"),
                value: "FeePerUnit"
              },
              {
                key: "prorated-by-price",
                label: I18n.t("Price prorata"),
                value: "FeeProratedByPrice"
              }
            ],
            value: {
              TAG: "Single",
              _0: value.globalFeeKind
            },
            onChange: selection => {
              if (typeof selection !== "object") {
                return;
              }
              if (selection.TAG !== "Single") {
                return;
              }
              let globalFeeKind = selection._0;
              setValue(prev => ({
                amount: prev.amount,
                globalFeeKind: globalFeeKind
              }));
            }
          }),
          JsxRuntime.jsx(Box.make, {
            children: JsxRuntime.jsx(NextBanner.make, {
              children: JsxRuntime.jsx(NextBanner.Text.make, {
                text: I18n.t("order_cart.global_fee_picker_modal.info_banner")
              }),
              variation: "info"
            }),
            spaceBottom: "normal"
          })
        ],
        space: "large"
      }),
      spaceX: "large",
      spaceY: "large"
    }),
    opened: props.opened,
    title: I18n.t("Global shipping costs"),
    variation: "secondary",
    backgroundColor: "#fefefe",
    renderStartText: () => JsxRuntime.jsx(Inline.make, {
      children: null,
      grow: true
    }),
    abortButtonText: I18n.t("Cancel"),
    commitButtonTone: "brand",
    commitButtonText: I18n.t("Apply"),
    commitButtonCallback: onCommit$1,
    onRequestClose: props.onRequestClose
  });
}

let make = React.memo(OrderCartGlobalFeePickerModal);

export {
  globalFeeKindToText,
  make,
}
/* make Not a pure module */
